import type React from "react";
import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { FormFieldText } from "@/components/FormFields/FormFieldText/FormFieldText";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";
import { type FormFieldComponentProps } from "@/lib/types/types";

interface PassedProps {
  explanation?: string | JSX.Element;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const EmailComponent = ({
  value,
  isErrored,
  onChange,
  explanation = "",
  onKeyDown = () => {},
  onBlur = () => {},
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps & PassedProps) => {
  const { msg } = useMessage();
  const isFieldHidden = getFieldConfigByFieldId("email")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="email"
      value={value}
      onChange={onChange}
      type="email"
      autoComplete="email"
      placeholder={placeholder || msg({ id: "emailAddressPlaceholder" })}
      label={<FormattedHTMLMessage id="emailAddress" defaultMessage="Email address" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidEmail" defaultMessage="Invalid email" />
        )
      }
      explanation={explanation}
      showPlaceholderAndHideLabel={!!placeholder}
      onKeyDown={(e) => onKeyDown(e)}
      onBlur={(e) => onBlur(e)}
      disabled={disabled}
    />
  );
};
